import React from 'react';
import { useQueryClient } from 'react-query';
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Popper from "@material-ui/core/Popper";
import _ from "underscore";

import { useAircraftRatesTails } from "../../../services/aircraft";

/* eslint-disable no-use-before-define */
const styles = (theme) => ({
  popper: {
    maxWidth: "fit-content"
  }
});

const AircraftInHourPool = props => {
  const queryClient = useQueryClient();
  const extraKeys = [props.value];
  const records = useAircraftRatesTails({queryClient, extraKeys});

  if (records && records.data && Array.isArray(records.data)) {
    if (records.data.length > 0) {
      const tailList = [];
      records.data.forEach(record => {
        if (!tailList.includes(record.aircraftTailNumber))
          tailList.push(record.aircraftTailNumber);
      })
      return <span>{tailList.join(", ")}</span>
    }
    return <></>
  }
  return <></>
}

export default withStyles(styles) (AircraftInHourPool);
